import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Grid, Tooltip, Button } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { getMaestras } from "../../actions/maestras-actions";
import { withStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));

export default function DetailedAccordionVacancies({
  headers,
  data,
  maestras,
  onView,
  dataContract,
  statusListContractType,
  onApply,
}) {
  const classes = useStyles();
  const id = IdKey.generate();

  const addDots = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        if (header.field === "salary") {
          return object[header.field] === 0
            ? "A convenir"
            : object[header.field]
            ? "$ " + addDots(object[header.field])
            : "";
        }
        if (header.field === "contractType" && statusListContractType ==="success") {
          let clave = object[header.field]?.toUpperCase();
          let valor = dataContract.find( contrato => contrato.contractTypes === clave);
          return valor ? valor.contractTypeDescription : ""
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {header.isRequisition
                  ? getValueByKey(data.requisition, header)
                  : getValueByKey(data, header)}
              </Typography>
            </div>
          ))}


          {!data?.userAlreadyApplied && <div className={classes.columnEvent}>
            <Tooltip title="Ver detalle" arrow placement="top">
              <VisibilityIcon className={classes.iconEvent} />
            </Tooltip>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              variant="contained"
              className={classes.buttonSearch}
              onClick={() => onApply(data.id)}
            >
              APLICAR
            </Button>
          </div>}
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.rootGrid}>
            <Grid container spacing={3}>
              {headers.otherHeaders.map((header) => (
                <Grid item xs={2}>
                  <Typography className={classes.heading}>
                    {header.title}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {header.isRequisition
                      ? getValueByKey(data.requisition, header)
                      : getValueByKey(data, header)}
                  </Typography>
                </Grid>
              ))}
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} style={{marginTop:"8px"}}>
                  <Typography className={classes.heading}>
                    OBSERVACIONES
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {data.observation}
                  </Typography>
                </Grid>

            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
